import React from 'react';
import { Link } from 'react-router-dom';
import mockupImgDesktop from '../assets/images/tmp_desktop.png';
import mockupImgMobile from '../assets/images/tmp_mobile.png';
import './Home.css';
import './Web.css';

function Web() {
    return (
        <div className="web-page">
            <section className="web-section bg-white" style={{ alignItems: 'center' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'flex-start' }}>
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>TVORBA WEBU
                    </div>
                    <h1 className="hp-h1">Web, který prodává</h1>
                    <p className="hp-sub" style={{ whiteSpace: 'pre-line' }}>
                        {"Web není vizitka.\nJe to nástroj, který má vysvětlit hodnotu a vést návštěvníka k akci.\nNavrhuji weby, které jsou rychlé, přehledné a připravené na měření výkonu."}
                    </p>
                    <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ marginTop: '16px' }}>
                        Chci probrat nový web
                    </a>
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <div className="web-mockup-container">
                        <div className="monitor-frame">
                            <img src={mockupImgDesktop} alt="Desktop Preview" className="monitor-screen" />
                        </div>
                        <div className="monitor-stand"></div>
                        <div className="monitor-base"></div>
                        <div className="phone-frame">
                            <img src={mockupImgMobile} alt="Mobile Preview" className="phone-screen" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="web-section bg-gray">
                <div className="fw-left">
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>KDE TEĎKA JSTE
                    </div>
                    <h2 className="hp-h2" style={{ fontSize: '36px' }}>Váš web existuje. Ale nepracuje.</h2>
                    <p className="hp-sub">To jsou řešitelné problémy. Nejdřív pochopím, co brzdí výkon — pak navrhneme konkrétní kroky.</p>
                </div>
                <div className="fw-right">
                    <div className="fw-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="fw-card-text">Web přivádí návštěvníky, ale ne poptávky. Nikdo nekontaktuje ani neobjednává.</p></div>
                    <div className="fw-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="fw-card-text">Nabídka není jasná. Návštěvník neví, co přesně nabízíte ani proč zrovna vy.</p></div>
                    <div className="fw-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="fw-card-text">Web není napojený na marketing. Každá kampaň začíná znovu od nuly.</p></div>
                    <div className="fw-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="fw-card-text">Analytika chybí nebo ji nikdo nesleduje. Nevíte, co funguje a kde se plýtvá.</p></div>
                    <div className="fw-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="fw-card-text">Změny probíhají chaoticky — bez jasného cíle nebo priority.</p></div>
                </div>
            </section>

            <section className="web-section bg-white web-section-col">
                <div className="gain-header">
                    <div className="hp-badge hp-badge-blue"><span className="dot"></span>CO ZÍSKÁTE</div>
                    <h2 className="hp-h2">Vše, co web potřebuje k výkonu</h2>
                </div>
                <div className="gain-grid">
                    <div className="gain-col">
                        <div className="gain-card"><h3 className="gain-card-title">Struktura a UX</h3><p className="gain-card-desc">Návštěvník se neztratí a ví, co má udělat.</p></div>
                        <div className="gain-card"><h3 className="gain-card-title">Copy a messaging</h3><p className="gain-card-desc">Jasná nabídka, důvěra, výzva k akci.</p></div>
                        <div className="gain-card"><h3 className="gain-card-title">Design na míru</h3><p className="gain-card-desc">Odpovídá vaší značce — žádné šablony.</p></div>
                    </div>
                    <div className="gain-col">
                        <div className="gain-card"><h3 className="gain-card-title">Rychlý technický základ</h3><p className="gain-card-desc">Mobil, rychlost, bezpečnost.</p></div>
                        <div className="gain-card"><h3 className="gain-card-title">SEO základ + analytika</h3><p className="gain-card-desc">Měření, cíle, události — víte, co funguje.</p></div>
                        <div className="gain-card"><h3 className="gain-card-title">Napojení na nástroje</h3><p className="gain-card-desc">Formuláře, kalendáře, e-mailing, CRM — dle potřeby.</p></div>
                    </div>
                </div>
            </section>

            <section className="web-section bg-gray web-section-col">
                <div className="gain-header">
                    <div className="hp-badge hp-badge-blue"><span className="dot"></span>JAK PRACUJEME</div>
                    <h2 className="hp-h2">Od prvního callu po spuštění</h2>
                </div>
                <div className="steps-grid">
                    <div className="step-card">
                        <div className="step-num">01</div>
                        <h3 className="step-title">Úvodní call</h3>
                        <p className="step-desc">Ujasníme si cíl webu, nabídku, cílovku a co má web dosáhnout.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">02</div>
                        <h3 className="step-title">Struktura a obsah</h3>
                        <p className="step-desc">Navrhneme sitemapu, logiku stránky a připravíme texty.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">03</div>
                        <h3 className="step-title">Design a vývoj</h3>
                        <p className="step-desc">Převedeme návrh do funkčního webu, otestujeme na mobilu i desktopu.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">04</div>
                        <h3 className="step-title">Spuštění a měření</h3>
                        <p className="step-desc">Nasazení, měření, základní SEO, předání a krátké zaškolení.</p>
                    </div>
                </div>
            </section>

            <section className="web-section bg-white web-section-col">
                <div className="gain-header" style={{ marginBottom: '0' }}>
                    <div className="hp-badge hp-badge-blue"><span className="dot"></span>VARIANTY</div>
                    <h2 className="hp-h2">Malé i velké projekty</h2>
                </div>
                <div className="price-grid">
                    <div className="price-card">
                        <h3 className="price-title">Prezentační web</h3>
                        <p className="price-desc">Ideální pro menší projekty a rychlý start.</p>
                        <p className="price-amount">od 5 000 Kč</p>
                        <p className="price-note">dle rozsahu obsahu a náročnosti</p>
                    </div>
                    <div className="price-card bg-blue">
                        <h3 className="price-title">Vícestránkový web</h3>
                        <p className="price-desc">Pro firmy, které potřebují jasnou strukturu služeb a větší důvěru.</p>
                        <p className="price-amount">Cena individuálně</p>
                        <p className="price-note">dle rozsahu projektu</p>
                    </div>
                    <div className="price-card">
                        <h3 className="price-title">Prodejní web / landing page</h3>
                        <p className="price-desc">Pro výkon a kampaně: konverze, testování, měření.</p>
                        <p className="price-amount">Cena individuálně</p>
                        <p className="price-note">dle cíle a rozsahu</p>
                    </div>
                </div>
            </section>

            <section className="web-section bg-gray web-section-col">
                <div className="gain-header" style={{ marginBottom: '0' }}>
                    <div className="hp-badge hp-badge-blue"><span className="dot"></span>FAQ</div>
                    <h2 className="hp-h2">Nejčastější otázky</h2>
                </div>
                <div className="faq-grid">
                    <div className="faq-card">
                        <p className="faq-q">Můžu začít malým webem a časem ho rozšířit?</p>
                        <p className="faq-a">Ano. Často je to nejchytřejší cesta: spustit rychle, měřit a stavět dál.</p>
                    </div>
                    <div className="faq-card">
                        <p className="faq-q">Dodáte i texty?</p>
                        <p className="faq-a">Ano — buď upravíme vaše podklady, nebo připravíme copy kompletně.</p>
                    </div>
                    <div className="faq-card">
                        <p className="faq-q">Co když už web mám?</p>
                        <p className="faq-a">Dává smysl začít rychlým zhodnocením a navrhnout, co upravit pro výkon.</p>
                    </div>
                </div>
            </section>

            <section className="web-cta-section">
                <h2 className="hp-h2" style={{ color: '#FFF', fontSize: '40px' }}>Chci probrat nový web</h2>
                <p className="hp-sub" style={{ color: 'rgba(255, 255, 255, 0.8)', maxWidth: '560px' }}>
                    Krátký call, kde si ujasníme směr a doporučím nejvhodnější postup.
                </p>
                <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-white" style={{ marginTop: '12px' }}>
                    Domluvit call
                </a>
            </section>
        </div>
    );
}

export default Web;
